import React from 'react';
import { Target, Eye, Book, Heart } from 'lucide-react';

export default function MissionPage() {
  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Mission Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12">
          <div className="flex items-center mb-6">
            <Target className="h-8 w-8 text-[#D4AF37] mr-4" />
            <h2 className="text-3xl font-bold text-[#064635]">Our Mission</h2>
          </div>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            Echoes of Ibadan is dedicated to preserving and digitizing the scholarly work of
            <strong> E.S.V. Tomori</strong>, a pioneering researcher and consultant whose publications
            through MACOS Consultancy have documented the rich history, traditions, and political organization
            of Yoruba kingdoms.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Our mission is to make this invaluable body of work freely accessible to researchers, students,
            historians, and anyone interested in Yoruba history and culture. By creating a comprehensive
            digital archive, we ensure that these important historical documents remain available for
            future generations to study, reference, and learn from.
          </p>
        </div>

        {/* Vision Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12">
          <div className="flex items-center mb-6">
            <Eye className="h-8 w-8 text-[#D4AF37] mr-4" />
            <h2 className="text-3xl font-bold text-[#064635]">Our Vision</h2>
          </div>
          <p className="text-lg text-gray-700 leading-relaxed">
            We envision a world where scholarly research on Yoruba history is freely accessible to all.
            Through careful digitization and preservation, we aim to bridge the gap between past and present,
            making E.S.V. Tomori's groundbreaking research available to the global academic community and
            to Yoruba people everywhere who seek to understand their rich heritage.
          </p>
        </div>

        {/* Core Values */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <Book className="h-8 w-8 text-[#D4AF37] mb-4" />
            <h3 className="text-xl font-semibold text-[#064635] mb-2">Scholarly Preservation</h3>
            <p className="text-gray-600">
              Digitizing and safeguarding E.S.V. Tomori's publications and research materials for
              academic use and historical reference, ensuring these important works remain accessible
              for generations to come.
            </p>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-6">
            <Heart className="h-8 w-8 text-[#D4AF37] mb-4" />
            <h3 className="text-xl font-semibold text-[#064635] mb-2">Open Access</h3>
            <p className="text-gray-600">
              Providing free, unrestricted access to these scholarly works for researchers, students,
              and the global community interested in Yoruba history, culture, and political traditions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}